module.exports = __webpack_public_path__ + "img/virusColectivo7.88fe96de.jpg";